import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

// import swal from 'sweetalert2';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoFornecedor } from '../../servicos/srv.produto';

@Component({
  selector: 'tsv2-frn-visualizar',
  templateUrl: './visualizar.component.html',
  providers: [ ServicoMsg, ServicoFornecedor ]
})
export class FornecedorVisualizarComponent implements OnInit {
  exibirBarra: boolean = true;

  p: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoFornecedor: ServicoFornecedor
  ) { }

  ngOnInit() {
    // this.spinner.show();
    const id = this.route.snapshot.params['id'];
    this.servicoFornecedor.consultarFornecedor(id).subscribe(res => {
      this.p = res.lista[0];
      // this.spinner.hide();
    }, (err) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err);
    });
  }

  removerFornecedor(id){
    let titulo = 'Remover o fornecedor?';
    let url = '/fornecedor/pesquisar/';
    let texto = 'Fornecedor removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoFornecedor, texto).then(r1 => {
      if (r1.success){
        this.router.navigate([url]);
      }
    }, (err: any) => {
      // this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
